/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const desktopLibraryPages = {
    ComputerLibraryPage: () => import('@/library/ComputerLibraryPage'),
    DownloadsPage: () => import('@/library/DownloadsPage'),
    localFilesSupported: () => import('@/localFiles/localFilesSupported'),
}
